// extracted by mini-css-extract-plugin
module.exports = {"page":"EmployeePositionsPage_page__Tb7nW","topSpan":"EmployeePositionsPage_topSpan__1QjUz","right":"EmployeePositionsPage_right__2ENPN"};